'use strict';


//import 'owl-carousel';

export default class News {
	constructor() {

		if( $("#news").length > 0 ) {
			$('.news-holder').delay(1500).fadeIn(500);
			
			var newsOwl = $('.owl-carousel#news');
			
			newsOwl.owlCarousel({
				loop:true,
				nav:false,
				items:1,
				autoplay:true,
				autoplayTimeout:8000,
				autoplaySpeed:500,
				autoplayHoverPause:true,
				responsiveClass:true,
				responsive:{
					0:{
						margin:15
					},
					1025:{
						margin: 100
					}	
				}
			});

			$(".news-prev").click(function(){
				newsOwl.trigger('prev.owl');
			})
			$('.news-play').on('click',function(){
				newsOwl.trigger('play.owl.autoplay',[8000])
				$(this).css('display','none');
				$('.news-stop').fadeIn();
			})
			$('.news-stop').on('click',function(){
				newsOwl.trigger('stop.owl.autoplay')
				$(this).css('display','none');
				$('.news-play').fadeIn();
			})
			$(".news-next").click(function(){
				newsOwl.trigger('next.owl');
			})
		}
	}
}
